/* 截图标注：形状模型 + 画布绘制（显示坐标 → 输出时按 scale 缩放、按选区偏移） */
export const COLORS = ["#ef4444", "#f59e0b", "#22c55e", "#3b82f6", "#111827", "#ffffff"];
export const TOOLS = ["rect", "arrow", "pen", "text"];

const arrowHead = (ctx, x0, y0, x1, y1, w) => {
  const a = Math.atan2(y1 - y0, x1 - x0), L = Math.max(10, w * 4);
  ctx.beginPath(); ctx.moveTo(x1, y1);
  ctx.lineTo(x1 - L * Math.cos(a - Math.PI / 6), y1 - L * Math.sin(a - Math.PI / 6));
  ctx.lineTo(x1 - L * Math.cos(a + Math.PI / 6), y1 - L * Math.sin(a + Math.PI / 6));
  ctx.closePath(); ctx.fill();
};

export function drawShape(ctx, s, k = 1, ox = 0, oy = 0) {
  const X = (v) => (v - ox) * k, Y = (v) => (v - oy) * k, w = (s.width || 3) * k;
  ctx.save();
  ctx.strokeStyle = s.color; ctx.fillStyle = s.color; ctx.lineWidth = w; ctx.lineCap = "round"; ctx.lineJoin = "round";
  ctx.shadowColor = s.color === "#ffffff" ? "rgba(0,0,0,.6)" : "rgba(0,0,0,.25)"; ctx.shadowBlur = 2 * k;
  if (s.type === "rect") {
    ctx.strokeRect(X(Math.min(s.x0, s.x1)), Y(Math.min(s.y0, s.y1)), Math.abs(s.x1 - s.x0) * k, Math.abs(s.y1 - s.y0) * k);
  } else if (s.type === "arrow") {
    ctx.beginPath(); ctx.moveTo(X(s.x0), Y(s.y0)); ctx.lineTo(X(s.x1), Y(s.y1)); ctx.stroke();
    arrowHead(ctx, X(s.x0), Y(s.y0), X(s.x1), Y(s.y1), w);
  } else if (s.type === "pen" && s.points?.length) {
    ctx.beginPath(); ctx.moveTo(X(s.points[0][0]), Y(s.points[0][1]));
    for (const [px, py] of s.points.slice(1)) ctx.lineTo(X(px), Y(py));
    ctx.stroke();
  } else if (s.type === "text" && s.text) {
    const fs = (s.fontSize || 16) * k;
    ctx.font = `600 ${fs}px -apple-system, "PingFang SC", "Microsoft YaHei", sans-serif`; ctx.textBaseline = "top";
    s.text.split("\n").forEach((line, i) => ctx.fillText(line, X(s.x0), Y(s.y0) + i * fs * 1.25));
  }
  ctx.restore();
}

export const drawAll = (ctx, shapes, k = 1, ox = 0, oy = 0) => shapes.forEach((s) => drawShape(ctx, s, k, ox, oy));
